export const SWAP_SLIPPAGE_THRESHOLD = 5 // 5%
export const SWAP_SLIPPAGE_DEFAULT_VALUE = 1 // 1%
